/**
 * Discount Constants
 */

export const VALUE_TYPE = {
  FLAT: 1,
  PERCENT: 2,
} as const;

export const DISCOUNT_OPTION = {
  ONE_TIME: 1,
  RECURRING: 2,
} as const;

export const DISCOUNT_LIMITS = {
  MAX_PERCENTAGE: 100,
  MAX_FLAT_AMOUNT: 10000,
} as const;

export type ValueType = typeof VALUE_TYPE[keyof typeof VALUE_TYPE];
export type DiscountOption = typeof DISCOUNT_OPTION[keyof typeof DISCOUNT_OPTION];

